import firebase from "firebase/compat/app";
import {
  doc,
  getFirestore,
  onSnapshot,
  setDoc,
  Unsubscribe,
  writeBatch,
} from "firebase/firestore";
import { DB_NODES } from "../../../../../db/constants/nodeNames";
import { AppUser, UpdatableAppUserJSON } from "../../../models/user/user";

class UserApi {
  private _authObserver: firebase.Unsubscribe | undefined;
  private _userDataObserver: Unsubscribe | undefined;

  async dangerouslyPermanentlyDeleteMe(userId: string): Promise<boolean> {
    let success = true;

    try {
      const db = getFirestore();
      const phoneSharingDoc = doc(db, DB_NODES.PHONE_NUMBER_SHARING, userId);
      const pushTokensDoc = doc(db, DB_NODES.PUSH_NOTIFICATION_TOKENS, userId);
      const userDoc = doc(db, DB_NODES.USERS, userId);

      const batch = writeBatch(db);
      batch.delete(phoneSharingDoc);
      batch.delete(pushTokensDoc);
      batch.delete(userDoc);

      await batch.commit();
    } catch (e) {
      success = false;
      console.error(e);
    }

    return success;
  }

  async updateUser(userId: string, json: UpdatableAppUserJSON) {
    const db = getFirestore();
    const document = doc(db, DB_NODES.USERS, userId);
    await setDoc(document, json, { merge: true });
  }

  registerUserObserver(callbackfn: (user: AppUser | null) => void) {
    this._authObserver = firebase.auth().onAuthStateChanged((user: any) => {
      // No user is logged in with firebase
      if (!user) {
        callbackfn(null);
        return;
      }

      // User is logged in with firebase
      try {
        // Convert firebase user to app user with firebase auth id and phone
        // number
        const firebaseUser = user as firebase.User;
        const appUser = AppUser.fromFirebaseUser(firebaseUser);

        // Attempt to add user information from firebase database
        const db = getFirestore();
        const document = doc(db, DB_NODES.USERS, user.uid);

        this._userDataObserver = onSnapshot(document, (doc) => {
          const data = doc.data();

          if (data) {
            appUser.addUpdatableAppUserJSON(data as UpdatableAppUserJSON);
          }

          callbackfn(appUser);
        });
      } catch (e) {
        console.error(e);
      }
    });
  }

  unregisterUserObserver() {
    this._authObserver?.();
    this._userDataObserver?.();
  }

  signOut() {
    firebase.auth().signOut();
  }
}

export default new UserApi();
